import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = ({ rightButton }) => {
  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          Spark<span className="labs-text">Labs</span><span className="llc-text"> LLC</span>
        </Link>
        <nav className="nav">
          {rightButton}
        </nav>
      </div>
    </header>
  );
};

export default Header;

